var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Form',{attrs:{"form":_vm.form}}),_c('v-btn',{staticClass:"mt-5",attrs:{"color":"primary"},on:{"click":_vm.loginAsUser}},[_vm._v("Prisijungti kaip")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }